import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { sortBy } from 'lodash';
import { DateUtils } from '@vectord/utils';
import { Tappable } from '@vectord/components';

import {
  selectedBulkUpdateSbatGroupsSelector,
  selectedBulkUpdateContestSbatGroupsSelector,
  setBulkSelectedSbatGroups,
} from 'features/classCreation';
import Field from 'components/Field';
import styles from './SelectedSbatGroupsForBulkUpdate.module.scss';
import classNames from 'classnames';

function SelectedSbatGroupsForBulkUpdate({
  highlightContests = false,
  isInstructorModal = false,
}) {
  const dispatch = useDispatch();
  const bulkSelectedSbatGroups = useSelector(
    selectedBulkUpdateSbatGroupsSelector
  );
  const contestSbatGroups = useSelector(
    selectedBulkUpdateContestSbatGroupsSelector
  );
  const selectedSbatGroupsCount = Object.keys(bulkSelectedSbatGroups).length;
  const selectedSbatGroups = Object.values(bulkSelectedSbatGroups);

  const sortedSbatGroups = useMemo(() => {
    return sortBy(
      selectedSbatGroups,
      (sbatGroup) => new Date(sbatGroup.date_of_topic)
    );
  }, [selectedSbatGroups]);

  const handleClick = () => {
    const nonContestSbatGroups = Object.keys(bulkSelectedSbatGroups)
      .filter((key) => !contestSbatGroups.includes(Number(key))) // Convert key to number for comparison
      .reduce((result, key) => {
        result[key] = bulkSelectedSbatGroups[key];
        return result;
      }, {});
    dispatch(setBulkSelectedSbatGroups(nonContestSbatGroups));
  };

  return (
    <>
      <Field
        label={`(${selectedSbatGroupsCount}) Upcoming Classes Selected`}
        labelClassName={styles.root}
        className="m-b-s"
      >
        {sortedSbatGroups.map((sbatGroup) => (
          <div
            key={sbatGroup.id}
            className={classNames(styles.selectedSbatGroup, {
              danger:
                highlightContests && contestSbatGroups.includes(sbatGroup.id),
            })}
          >
            {`${DateUtils.toDDMMM(sbatGroup.date_of_topic)}, `}
            {sbatGroup.academy_topic.title}
          </div>
        ))}
      </Field>
      {isInstructorModal && contestSbatGroups.length > 0 && (
        <Tappable
          className="btn btn-primary m-b-s"
          onClick={handleClick}
        >
          Remove Contests
        </Tappable>
      )}
    </>
  );
}

export default SelectedSbatGroupsForBulkUpdate;
